import { useInputState } from './useInputState';

const validations = [
  {
    validate: (value) => value && value.trim && !!value.trim(),
    errorMessage: 'streetNameRequiredError'
  },
  {
    validate: (value) => value && value.length <= 40,
    errorMessage: 'invalidStreetNameLength'
  }
];

export function useStreetNameInputState(options) {
  return useInputState({
    initialValue: '',
    validations,
    ...(options || {})
  });
}
